import React, { useState } from "react";
import Modal from "../components/Modal/Modal";
import styles from "./ExportModal.module.scss";
import MultiSelectSimple from "../components/MultiSelectSimple/MultiSelectSimple";
import Button from "../components/Button/Button";
import axiosInstance from "../utils/utils";
import { useParams } from "react-router-dom";
import { hideModal } from "../redux/modalStore";
import { useDispatch } from "react-redux";
import { ReactComponent as ExportIcon } from "../icons/export.svg";
import { useTranslation } from "react-i18next";

const multiSelectOptions = [
  { id: 1, label: "Findings", key: "findings" },
  { id: 2, label: "Improvement Projects", key: "improvements" },
  { id: 3, label: "Audits", key: "audit_tasks" },
  { id: 4, label: "Audit Forms", key: "audits" },
  { id: 5, label: "Permits", key: "permits" },
];

const ExportModal = () => {
  const { orgId } = useParams();
  const sessionToken = localStorage.getItem("session_token");
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const [selectedValues, setSelectedValues] = useState([]);

  const handleExport = async () => {
    const selectedKeys = selectedValues.map(
      (id) => multiSelectOptions.find((option) => option.id === id)?.key,
    );

    try {
      await exportExcel(orgId, sessionToken, selectedKeys);
      setSelectedValues([]);
    } catch (error) {
      console.error("Error during export:", error);
    }
  };

  const exportExcel = async (orgId, sessionToken, selectedKeys) => {
    const params = {
      org_id: orgId,
      findings: selectedKeys.includes("findings"),
      improvements: selectedKeys.includes("improvements"),
      audit_tasks: selectedKeys.includes("audit_tasks"),
      audits: selectedKeys.includes("audits"),
      permits: selectedKeys.includes("permits"),
    };

    try {
      const options = {
        method: "GET",
        url: "export/excel",
        params,
        headers: { "session-token": sessionToken },
        responseType: "blob",
      };

      const response = await axiosInstance.request(options);

      // Generate dynamic filename based on selected options and date
      const selectedLabels = selectedKeys
        .map(
          (key) =>
            multiSelectOptions.find((option) => option.key === key).label,
        )
        .join("_");

      // Generate the date (YYYY-MM-DD)
      const date = new Date().toISOString().slice(0, 10); // get only date

      // Filename with selected labels and date
      const filename = `export_${selectedLabels}_${date}.xlsx`;

      // Handle file download
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", filename);
      document.body.appendChild(link);
      link.click();
    } catch (error) {
      console.error("Error exporting Excel:", error);
    }
  };

  const handleModalClose = () => {
    // Reset selected values when modal is closed
    setSelectedValues([]);
    dispatch(hideModal());
  };

  return (
    <Modal
      name="export_modal"
      title={t("exportModal.title")}
      width="40vw"
      onClose={handleModalClose}
    >
      <div className={styles.content}>
        <div className={styles.text}>{t("exportModal.selectText")}</div>
        <div className={styles.wrapper}>
          <MultiSelectSimple
            options={multiSelectOptions}
            selectedValues={selectedValues}
            onChangeSelectedValues={setSelectedValues}
          />
        </div>
        <Button
          text={t("exportModal.exportExcelButton")} className={styles.exportButton}
          onClick={handleExport}
          disabled={selectedValues.length === 0}
          icon={<ExportIcon />}
          iconPosition="right"
        />
      </div>
    </Modal>
  );
};

export default ExportModal;
